/* eslint-disable */
import { protoLib as lib } from '@tock/coretypes';

import protoDefs from '@tock/protos/dist/core.json';

lib
  .define('tocktix.messages')
  .addJSON(protoDefs.nested.tocktix.nested.messages.nested)
  .addJSON(protoDefs.nested.tocktix.nested.messages.nested.enums.nested);
lib
  .define('tocktix.proto.dashboard')
  .addJSON(protoDefs.nested.tocktix.nested.proto.nested.dashboard.nested);
const resolvedRoot = lib.resolveAll();
export default {
  ...resolvedRoot.lookup('tocktix.messages'),
  ...resolvedRoot.lookup('tocktix.messages.enums'),
} as any;
